import React, { useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../App.css';
const Signup = () => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirm_password) {
            return toast.error("Passwords do not match!");
        }
        setLoading(true);
        try {
             const response = await API.post('/signup', formData);
             localStorage.setItem('userEmail', formData.email);
             toast.success(response.data.message);
             navigate('/verify'); // Signup ke baad seedha verify par bhej rahe hain
         } catch (error) {

             const errorMsg = error.response?.data?.detail || "Signup failed!";
             toast.error(Array.isArray(errorMsg) ? errorMsg[0].msg : errorMsg);
         } finally {
             setLoading(false);
         }
    };
    return (
        <div className="main-bg">
            <div className="brand-section">
                <h1>Cortex</h1>
                <p>Start your journey towards a more organized life. Join us today.</p>
            </div>
            <div className="auth-container">
                <h2>Create Account</h2>
                <form onSubmit={handleSubmit}>
                    <input type="text" placeholder="Username" onChange={(e) => setFormData({...formData, username: e.target.value})} required />
                    <input type="email" placeholder="Email" onChange={(e) => setFormData({...formData, email: e.target.value})} required />
                    <input type="password" placeholder="Password" onChange={(e) => setFormData({...formData, password: e.target.value})} required />
                    <input type="password" placeholder="Confirm Password" onChange={(e) => setFormData({...formData, confirm_password: e.target.value})} required />
                    <button type="submit" disabled={loading}>
                        {loading ? <span className="spinner"></span> : "Sign Up"}
                    </button>
                </form>
                <p className="auth-text">
    Already have an account? <span className="white-link" onClick={() => navigate('/login')}>Login</span>
</p>
            </div>
        </div>
    );
};

export default Signup;